import { render, staticRenderFns } from "./FieldBoardCouncil.vue?vue&type=template&id=61108785&"
import script from "./FieldBoardCouncil.vue?vue&type=script&lang=js&"
export * from "./FieldBoardCouncil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports